import React, {useEffect, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import MaterialReactTable//, { MRT_FilterOption } 
, { MRT_DensityState,
MRT_FullScreenToggleButton,
  MRT_GlobalFilterTextField,
MRT_RowSelectionState, MRT_ShowHideColumnsButton, MRT_TableInstance, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleGlobalFilterButton, MRT_ToolbarAlertBanner, MRT_ToolbarDropZone, MRT_VisibilityState }from 'material-react-table';
import { MRT_Localization_FA } from 'material-react-table/locales/fa';
import { Button, IconButton, Tooltip } from '@mui/material';
//import RefreshIcon from '@mui/icons-material/Refresh';
import FilterIcon from '@mui/icons-material/FilterAlt';
import ExportIcon from '@mui/icons-material/FilePresent';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { IMrt_grid_prop_server } from './IMrt_grid_prop_server';
import type {
  ColumnFiltersState,
  PaginationState,
  SortingState,
} from '@tanstack/react-table';
import { IMrt_ApiResponse } from './IMrt_ApiResponse';
import { CSVLink } from "react-csv";
import MrtRefreshCounter from './MrtRefreshCounter';

function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}

interface IColumnFns {
  id: string;
  fns: string;
}

interface IColumnFilters {
  id: string;
  value: string;
  fns: string;
}

interface ISorting{
  id: string;
  desc: boolean;
}
export interface IGridPageFilterDto {
  start: number;
  size: number;
  filter: IColumnFilters[];
  globalFilter: string;
  sorting: ISorting[];
}

const MrtGridServer = ({
    disableStickyFooter,
    stickyOffset,
    enableGrouping,
    disableFilters,
    disableColumnResizing,
    disableColumnFilterModes,
    disableStickyHeader,
    disableSorting,
    disableFullScreenToggle,
    disablePagination,
    disableHiding,
    disableTableFooter,
    disableTopToolbar,
    disableBottomToolbar,
    disableColumnActions,
    disableGlobalFilter,

    enablePinning,
    enableColumnOrdering,
    enableColumnDragging,
    enableClickToCopy,
    enableRowSelection,
    enableSelectAll,
    enableMultiRowSelection,
    enableExcelExport,
    enableDarkMode,
    enableRefreshCounter,
    enableDensityToggle,
    
    headerColor,
    initialState_showColumnFilters,
    initialState_paginationSize,
    initialState_columnPinning_left,
    initialState_columnPinning_right,
    initialState_columnVisibility,
    initialState_columnSorting,
    columns,
    serverUrl,
    onCustomFilterClick,
    rowActions,
    topToolbarCustomActions,
    //extraPostBody ,
    server,
    refetchData,
    onRowSelection,
    disableAutoRenderRowActions,
    rowActionsRenderer,name,
    getRowId,
    renderDetailPanel,
    enableExpandAll,
    // muiExpandButtonProps,
    // muiDetailPanelProps
     }: IMrt_grid_prop_server ) => {
      const isFirstRender = useRef(true);

      //data and fetching state
  const [data, setData] = useState<Array<any>>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [initLoad, setInitLoad] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [columnFiltersFns, setColumnFiltersFns] = useState<Array<IColumnFns>>([]);
  
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<SortingState>([]);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: initialState_paginationSize || 15,
  });

  const [refetch, setRefetch] = useState(false);

  const handleColumnFilterFns = (fn : any) => {
    let fnObj = fn();

    if(fnObj && Object.keys(fnObj).length > 0 ){
      let key = Object.keys(fnObj)[0];
      var fns = columnFiltersFns.filter(f => f.id !== key );
      console.log([...fns , {id:key, fns: fnObj[key]}]);
      setColumnFiltersFns([...fns , {id:key, fns: fnObj[key]}]);
    }
  };
  
  
  //if you want to avoid useEffect, look at the React Query example instead
  useEffect(() => {
    if(!initLoad){ setInitLoad(true); return; }

    const fetchData = async () => {
      try {
        if (!data.length) { setLoading(true); } 
        else { setIsRefetching(true); }

      /*
      const url = new URL(serverUrl );
      url.searchParams.set(
        'start',
        `${pagination.pageIndex * pagination.pageSize}`,
      );
      url.searchParams.set('size', `${pagination.pageSize}`);
      url.searchParams.set('filters', JSON.stringify(columnFilters ?? []));
      url.searchParams.set('globalFilter', globalFilter ?? '');
      url.searchParams.set('sorting', JSON.stringify(sorting ?? []));
      */

      /*const response = await fetch(url.href, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': serverAuthHeader || ""
        },
        body: //extraPostBody ? JSON.stringify(extraPostBody) : undefined
        JSON.stringify({ 
          start: pagination.pageSize, 
          size : pagination.pageIndex * pagination.pageSize,
          filter: columnFiltersFull,
          globalFilter: globalFilter,
          sorting: sorting, 
        } as IGridPageFilterDto)
        });*/

        const response = await server.post(serverUrl, { 
          size  : pagination.pageSize, 
          start : pagination.pageIndex * pagination.pageSize,
          filter: columnFilters.map((m:any) => {
            let colFns = columnFiltersFns.find(f => f.id == m.id);
            var filterFn = isNaN(+m.value)? 'contains' : 'equals';
            return {...m, ...{fns: colFns ? colFns : filterFn}};
            }), // columnFiltersFull,
          globalFilter: globalFilter || '',
          sorting: sorting.length > 0 ? sorting : initialState_columnSorting, 
        } as IGridPageFilterDto);

        const json = response.data as IMrt_ApiResponse;
        setData(json.data);
        setRowCount(json.meta.totalRowCount);

      } catch (error) {
        setIsError(true);
        setLoading(false);
        console.error(error);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    refetch
    //extraPostBody    
  ]);

  useEffect(() => {
    setRefetch(!refetch);
  }, [refetchData])
  
  
    // windows size process
    const [windowSize, setWindowSize] = React.useState(getWindowSize());

    React.useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }

      window.addEventListener('resize', handleWindowResize);

      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);
    
    
    const craeteExcelData = (dt: any) => {
      //console.log(dt);
      return dt.map((m:any) => {
        columns.forEach((col:any) => {
          if(col.accessorFn){
            let obj:any = {};
            obj[`${col.id}`] = col.accessorFn(m);
            m = {...m, ...obj}
          }
        });
        return m;
      });
    }

    const craeteExcelHeader = () => {
      //console.log(columns);
      return columns.map((c:any) =>  {
        return { label: c.header, key: c.id }
      });
    }
    
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

    useEffect(() => {
      let t = tableInstanceRef.current?.getSelectedRowModel();
      
      if(onRowSelection ){
        if (t?.rows && t?.rows.length > 0){
          enableMultiRowSelection 
              ? onRowSelection(t?.rows.map((m: any)=> m.original)) 
              : onRowSelection(t?.rows[0].original);
        }
        else{
          onRowSelection(undefined);
        }
      }
    }, [rowSelection]);

    const tableInstanceRef = React.useRef<MRT_TableInstance<any>>(null); //ts

    var actionWidth = 6;
    if(rowActions?.length??0 > 0 ){
      rowActions?.map(m => actionWidth += (((m.title??'123456').length) * 8 + 25) );
    }



    const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>({});
    const [density, setDensity] = useState<MRT_DensityState>('compact');
    //const [globalFilter, setGlobalFilter] = useState<string | undefined>(undefined);
    const [showGlobalFilter, setShowGlobalFilter] = useState(false);
    const [showColumnFilters, setShowColumnFilters] = useState(false);

    function getUniqName(params: string) {
      return  window.location.pathname  + '/' + name + '/' + params;
    }
      //load state from local storage 
    useEffect(() => {
      const columnFilters = localStorage.getItem(getUniqName('mrt_columnFilters'));
      const columnVisibility = localStorage.getItem(
        getUniqName('mrt_columnVisibility'),
      );
      const density = localStorage.getItem(getUniqName('mrt_density'));
      const globalFilter = localStorage.getItem(getUniqName('mrt_globalFilter'));
      const showGlobalFilter = localStorage.getItem(
        getUniqName('mrt_showGlobalFilter'),
      );
      const showColumnFilters = localStorage.getItem(
        getUniqName('mrt_showColumnFilters'),
      );
      const sorting = localStorage.getItem(getUniqName('mrt_sorting'));

      if (columnFilters) {
        setColumnFilters(JSON.parse(columnFilters));
      }
      if (columnVisibility) {
        setColumnVisibility(JSON.parse(columnVisibility));
      }
      if (density) {
        setDensity(JSON.parse(density));
      }
      if (globalFilter) {
        setGlobalFilter(JSON.parse(globalFilter) || undefined);
      }
      if (showGlobalFilter) {
        setShowGlobalFilter(JSON.parse(showGlobalFilter));
      }
      if (showColumnFilters) {
        setShowColumnFilters(JSON.parse(showColumnFilters));
      }
      if (sorting) {
        setSorting(JSON.parse(sorting));
      }
      isFirstRender.current = false;
    }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_columnFilters'),
      JSON.stringify(columnFilters),
    );
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_columnVisibility'),
      JSON.stringify(columnVisibility),
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(getUniqName('mrt_density'), JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_globalFilter'),
      JSON.stringify(globalFilter ?? ''),
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_showGlobalFilter'),
      JSON.stringify(showGlobalFilter),
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_showColumnFilters'),
      JSON.stringify(showColumnFilters),
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(getUniqName('mrt_sorting'), JSON.stringify(sorting));
  }, [sorting]);
  
  const resetState = () => {
    localStorage.removeItem(getUniqName('mrt_columnFilters'));
    localStorage.removeItem(getUniqName('mrt_columnVisibility'));
    localStorage.removeItem(getUniqName('mrt_density'));
    localStorage.removeItem(getUniqName('mrt_globalFilter'));
    localStorage.removeItem(getUniqName('mrt_showGlobalFilter'));
    localStorage.removeItem(getUniqName('mrt_showColumnFilters'));
    localStorage.removeItem(getUniqName('mrt_sorting'));
    window.location.reload();
  };



  return (
    <MaterialReactTable
        tableInstanceRef={tableInstanceRef}

        enableColumnActions={!disableColumnActions}
        enableFilters={!disableFilters}
        enableHiding={!disableHiding}
        enableTableFooter={!disableTableFooter}
        enableClickToCopy={enableClickToCopy}
        enablePagination={!disablePagination}
        enableFullScreenToggle={!disableFullScreenToggle}
        enableSorting={!disableSorting}
        enableColumnFilterModes={!disableColumnFilterModes}
        enableColumnOrdering={enableColumnOrdering}
        enablePinning={enablePinning}
        enableRowActions={rowActions && rowActions.length > 0}
        enableRowSelection={enableRowSelection}
        enableDensityToggle={enableDensityToggle?true:false}
        enableColumnResizing={!disableColumnResizing}
        enableTopToolbar={!disableTopToolbar}
        enableBottomToolbar={!disableBottomToolbar}
        enableSelectAll={enableSelectAll}
        enableMultiRowSelection={enableMultiRowSelection}
        enableGlobalFilter={!disableGlobalFilter}
        renderRowActions={({ cell,row,table }) => (
          <React.Fragment>
         {!disableAutoRenderRowActions===true &&  <Box key={row.index} sx={{ display: 'flex', gap: '0.6rem', p: '2px' }}>
            {rowActions?.map(m => 
               <React.Fragment key={row.index} >{(!m.tooltip || !m.icon) &&
                  <Button disabled={m.disabled} style={{display: m.hidden ? "none" : "block"}}  key={row.index} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(row.original)}>
                    {m.title} {m.icon}
                  </Button>
               }</React.Fragment>
            )}
            {rowActions?.map(m => <React.Fragment key={row.index} >{(m.tooltip && m.icon) &&
              <Tooltip key={row.index} arrow title={m.tooltip}>
                  <IconButton onClick={() => m.handleClick(row.original)} >
                  {m.title} {m.icon}
                  </IconButton>
              </Tooltip> }</React.Fragment>
            )} 
          </Box>}
          {disableAutoRenderRowActions===true && rowActionsRenderer(cell,row,table)}
          </React.Fragment>
        )}
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'عمليات', //change header text
            size: actionWidth, //make actions column wider,
          },
        }}
        enableStickyHeader={!disableStickyHeader}
        enableStickyFooter={!disableStickyFooter}
        muiTableContainerProps={!disableStickyFooter ? 
          { sx: { maxHeight: (windowSize.innerHeight - (stickyOffset || 0)) + 'px' } } : undefined}
        enableGrouping={enableGrouping}
        enableColumnDragging={enableColumnDragging}
        groupedColumnMode = "reorder"
        initialState={{ 
          showColumnFilters: initialState_showColumnFilters, 
          showGlobalFilter: false , 
          columnPinning: { left: initialState_columnPinning_left , right: initialState_columnPinning_right},
          pagination: { pageSize: initialState_paginationSize || 50, pageIndex: 0 }, 
          density: 'compact',
          columnVisibility: initialState_columnVisibility && initialState_columnVisibility.length > 0
            ? Object.assign({},...initialState_columnVisibility) : {}
        }}
        localization={MRT_Localization_FA}
        columns={columns} 
        data={data} 
        renderDetailPanel={renderDetailPanel}
        enableExpandAll={enableExpandAll}
        // muiExpandButtonProps={muiExpandButtonProps}
        // muiDetailPanelProps={muiDetailPanelProps}
        getRowId={getRowId}
        renderTopToolbar={({ table }) => (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '0rem', padding: '4px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'start', padding: '2px'}}>
                {/* <Tooltip arrow title=" بازخواني اطلاعات">
                  <IconButton onClick={async() => await onNeedData()}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>  */}
                {onCustomFilterClick && <Tooltip arrow title="شرايط گزارش">
                  <IconButton onClick={() => onCustomFilterClick()} style={{marginLeft: 7}}>
                    <FilterIcon />
                  </IconButton>
                </Tooltip>}
                {topToolbarCustomActions?.map((m,i) =>   
                <React.Fragment key={i}> 
                  {(!m.tooltip || !m.icon) &&
                    <Button disabled={m.disabled} style={{marginLeft:'2px'}} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(table)}>
                      {m.icon && m.icon} {m.title} 
                    </Button>}
                </React.Fragment>)}
                {topToolbarCustomActions?.map((m,i) =>   
                <React.Fragment key={i}> 
                  {(m.tooltip && m.icon) &&
                    <Tooltip arrow title={m.tooltip}>
                      <IconButton disabled={m.disabled} onClick={() => m.handleClick(table)} >
                        {m.icon}
                      </IconButton>
                    </Tooltip>}
                  </React.Fragment>
                )}
              </Box>
              <Box sx={{ display: 'flex', flex: 'auto'}}>
                <MRT_ToolbarDropZone table={table}/>
                <MRT_ToolbarAlertBanner table={table} stackAlertBanner={true}/>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end'}}>
                <MrtRefreshCounter title="بازخواني" refreshFn={() => setRefetch(!refetch)} enable={enableRefreshCounter ? 'true' : 'false'}/>
                {enableExcelExport && <Tooltip arrow title="خروجي اكسل">
                  <IconButton>
                  <CSVLink data={craeteExcelData(data)} style={{color:'gray'}} headers={craeteExcelHeader()}>
                      <ExportIcon />
                    </CSVLink>            
                  </IconButton>
                </Tooltip>}
                {!disableFilters && !disableGlobalFilter && <MRT_GlobalFilterTextField table={table} />}
                {!disableFilters && !disableGlobalFilter && <MRT_ToggleGlobalFilterButton table={table} />}
                {!disableFilters && <MRT_ToggleFiltersButton table={table} />}
                <MRT_ShowHideColumnsButton table={table} />
                {enableDensityToggle && <MRT_ToggleDensePaddingButton table={table} />}
                <Tooltip arrow title="بازنشاني تنظيمات جدول">
                  <IconButton onClick={resetState} >
                    <RestoreFromTrashIcon />
                  </IconButton>
                </Tooltip>
                {!disableFullScreenToggle && <MRT_FullScreenToggleButton table={table} />}
            </Box>
          </Box>
        )}
        renderTopToolbarCustomActions={({ table }) => (
          <Box sx={{ display: 'flex', gap: '1rem', p: '4px' }}>
            {/* <Tooltip arrow title=" بازخواني اطلاعات">
              <IconButton onClick={async() => await onNeedData()}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>  */}
            <MrtRefreshCounter title="بازخواني" refreshFn={() => setRefetch(!refetch)} enable={enableRefreshCounter ? 'true' : 'false'}/>
            {onCustomFilterClick && <Tooltip arrow title="شرايط گزارش">
              <IconButton onClick={() => onCustomFilterClick()} >
                <FilterIcon />
              </IconButton>
            </Tooltip>}
            {enableExcelExport && <Tooltip arrow title="خروجي اكسل">
              <IconButton>
              <CSVLink data={craeteExcelData(data)} style={{color:'gray'}} headers={craeteExcelHeader()}>
                  <ExportIcon />
                </CSVLink>            
              </IconButton>
            </Tooltip>}
            <Tooltip arrow title="بازنشاني تنظيمات جدول">
              <IconButton onClick={resetState} >
                <RestoreFromTrashIcon />
              </IconButton>
            </Tooltip>
            {topToolbarCustomActions?.map((m,i) =>   
              <React.Fragment key={i}> 
                {(!m.tooltip || !m.icon) &&
                  <Button color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(table)}>
                    {m.icon && m.icon} {m.title} 
                  </Button>}
              </React.Fragment>)}
            {topToolbarCustomActions?.map((m,i) =>   
            <React.Fragment key={i}> 
              {(m.tooltip && m.icon) &&
                <Tooltip arrow title={m.tooltip}>
                  <IconButton onClick={() => m.handleClick(table)} >
                    {m.icon}
                  </IconButton>
                </Tooltip>}
              </React.Fragment>
            )}
          </Box>
        )}
        muiTableHeadProps={{
          sx: {
            '& tr, tr th': {
              backgroundColor: headerColor ?? (enableDarkMode ? '#003636' : '#e5f6fd'), //'#f0f0f0',//'#e5f6fd',//
              fontSize: '13px',
              padding: '0.6rem'
            },
          }                          
        }}
        muiTableBodyProps={enableRowSelection
          ?{
            sx: {
              '& tr td': {
                fontSize: '13px'
              },
            }         
          }
          :{
          sx: {
            '& tr td': {
              fontSize: '13px'
            },
            '& tr:nth-of-type(odd)': {
              backgroundColor: enableDarkMode ? '#1a1a1a' : '#fafdff'
            },
          }         
        }}
        positionToolbarAlertBanner="bottom"

        manualFiltering
        manualPagination
        manualSorting
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onColumnFilterFnsChange={handleColumnFilterFns}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        rowCount={rowCount}
        state={{
          columnFilters,
          globalFilter: globalFilter || '',
          isLoading: loading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
          rowSelection,

          columnVisibility,
          density,
          showColumnFilters,
          showGlobalFilter,
        }}
        onRowSelectionChange={setRowSelection}
        muiTableBodyRowProps={({ row }) => ({
          //add onClick to row to select upon clicking anywhere in the row
          onClick: (event: any) => {
            //event.preventDefault();
                          console.log(event.target.localName)

            if (event.target.localName != 'button' && event.target.localName != 'text' &&  event.target.localName != 'path' &&  event.target.localName != 'svg') row.toggleSelected();
          },
          sx: { cursor: 'pointer' },
        })}
        //onColumnFiltersChange={setColumnFilters}
        onColumnVisibilityChange={setColumnVisibility}
        onDensityChange={setDensity}
        //onGlobalFilterChange={setGlobalFilter}
        onShowColumnFiltersChange={setShowColumnFilters}
        onShowGlobalFilterChange={setShowGlobalFilter}
        //onSortingChange={setSorting}
    />
  );
}

export default MrtGridServer;